<template>
  <v-dialog v-model="dialog" max-width="400" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <div class="d-flex align-items-center justify-content-center">
        <v-btn
          color="#3F4443"
          rounded
          outlined
          small
          class="ml-5 text-uppercase"
          v-bind="attrs"
          v-on="on"
          :disabled="state === 'OFF'"
        >
          Delete
        </v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title>Delete Device</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        Are you sure you want to delete this?
      </v-card-text>
      <v-card-actions class="d-flex align-items-center justify-content-center">
        <v-btn color="#717C7D" text @click="dialog = false">{{
          $t("lang.location_form.btn_cancel")
        }}</v-btn>
        <v-btn color="#9ac31c" text @click="submitForm">{{
          $t("lang.admin.device_form.btn_done")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["id", "state"],
  data() {
    return {
      dialog: false
    };
  },
  methods: {
    async submitForm() {
      try {
        let response = await this.$api.nms.delete_application(this.id);
        this.dialog = false;
        console.log("response", response);
      } catch (error) {
        console.log("error", error);
      }
    }
  }
};
</script>
